// Frontend error tracking. Active only when REACT_APP_SENTRY_DSN is set at build time.
// Loaded via dynamic import so the SDK ships as a separate chunk that is never fetched
// when Sentry is disabled.
export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;
  import("@sentry/react")
    .then((Sentry) => {
      Sentry.init({
        dsn,
        environment: process.env.REACT_APP_SENTRY_ENV || "production",
        tracesSampleRate: 0,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
      });
    })
    .catch(() => { /* never let analytics break the app */ });
}
